import React from 'react';
import styled from 'styled-components';
import { ModalFactory, Text } from '../../../../components';
import { toRem } from '../../../../design';

const ModalSectionTitle = styled(Text)`
  margin-bottom: ${toRem(16)};
  align-self: start;
`;

export const TipCalculationsMethodInfoModal = ({ hideModal }: { hideModal: () => void }) => (
  <ModalFactory onClose={hideModal} isActive>
    <ModalSectionTitle className="points" fontWeight="semibold">
      Tip Sharing
    </ModalSectionTitle>
    <Text size="small">
      Tip sharing is a method where tips received by one job role are distributed to other job role(s) according to a specified percentage.
      <br /> <br />
      For instance, if servers collect $1000 in tips and are set to share 3% with bussers, a pool of $30 would be created for the bussers. This amount is then divided among the bussers based on the hours each individual worked.
      <br /> <br />A rule is required for every job that will ring in tips in your point of sale. This will be servers and bartenders at most restaurants, but some restaurants may have other staff that would ring in tips.
    </Text>
  </ModalFactory>
);
